/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BatchSummary } from './BatchSummary';
import {
    BatchSummaryFromJSON,
    BatchSummaryFromJSONTyped,
    BatchSummaryToJSON,
    BatchSummaryToJSONTyped,
} from './BatchSummary';

/**
 * 
 * @export
 * @interface BulkDeleteTimesheetEntriesResponse
 */
export interface BulkDeleteTimesheetEntriesResponse {
    /**
     * 
     * @type {BatchSummary}
     * @memberof BulkDeleteTimesheetEntriesResponse
     */
    data: BatchSummary;
}

/**
 * Check if a given object implements the BulkDeleteTimesheetEntriesResponse interface.
 */
export function instanceOfBulkDeleteTimesheetEntriesResponse(value: object): value is BulkDeleteTimesheetEntriesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function BulkDeleteTimesheetEntriesResponseFromJSON(json: any): BulkDeleteTimesheetEntriesResponse {
    return BulkDeleteTimesheetEntriesResponseFromJSONTyped(json, false);
}

export function BulkDeleteTimesheetEntriesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkDeleteTimesheetEntriesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': BatchSummaryFromJSON(json['data']),
    };
}

  export function BulkDeleteTimesheetEntriesResponseToJSON(json: any): BulkDeleteTimesheetEntriesResponse {
      return BulkDeleteTimesheetEntriesResponseToJSONTyped(json, false);
  }

  export function BulkDeleteTimesheetEntriesResponseToJSONTyped(value?: BulkDeleteTimesheetEntriesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': BatchSummaryToJSON(value['data']),
    };
}

